module.exports = __webpack_public_path__ + "cover-letter-47f61a13/template-4-preview-f0ab9a23ced3df7726bdb258cdd4071d.jpg";